import React, { useState, useEffect } from "react";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import {
  get_advisorsList_list,
  admin_advisors_delete,
  get_mou_list,
  admin_mou_delete,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";

export default function View(props) {
  const [data, setData] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const onSearch = () => {
    //
  };

  const handleMouList = async () => {
    setIsActive(true);
    try {
        const res = await get_mou_list(adminType);
        const tdata = Array.isArray(res) 
            ? res.map((item, index) => ({
                ...item, 
                slno: index + 1, 
            })) 
            : [];

        setData(tdata);
    } catch (error) {
        console.error("Error fetching MOU list:", error);
        setData([]); 
    } finally {
        setIsActive(false);
    }
};

  

  useEffect(() => {
    handleMouList();
  }, []);

  useEffect(() => {
    return () => {
      setData([]);
    };
  }, []);

  const handleEdit = (row) => {
    let path = `/admin-mou-edit/${row.id}`;
    props.history.push(path);
  };

  const handleAddNew = () => {
    let path = "/admin-mou-add";
    props.history.push(path);
  };

  const handleView = (data) => {
    let path = `/admin-mou-view/${data.id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };

  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_mou_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleMouList();
    }
  };

  const handleDownload = () => {};

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <h6>
          <b>MOU</b>
        </h6>
        <hr />
        {/* --------------admin----- */}
        {adminType === 1 && (
          <>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => handleAddNew(e)}
            >
              Add New
            </button>
            <CustomTable
              {...props}
              columns={[
                // { title: "Image", field: "photo", type: "image" },
                { title: "Sl No", field: "slno" },
                { title: "Organization", field: "organization_name" },
                { title: "Signatory from KSPACE", field: "kspace_signatory_area" },
                // {
                //   title: "Signatory from partner organization",
                //   field: "partner_signatory_area",
                // },
                // { title: "Logo", field: "logo", type: "imageFull" },
                // { title: "Domain listing", field: "domain_list" },
                { title: "Start Date", field: "from_date", type: "fullDate" },
                { title: "End Date", field: "to_date", type: "fullDate" },
                { title: "Status", field: "status", type: "mouStatus", }
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
              ]}
            />
          </>
        )}
        {/* ----------------- */}
        {/* --------------admin----- */}
        {adminType === 2 && (
          <>
            <CustomTable
              {...props}
              columns={[
                // { title: "Image", field: "photo", type: "image" },
                { title: "Sl No", field: "slno" },
                { title: "Organization", field: "organization_name" },
                { title: "Signatory from KSPACE", field: "kspace_signatory_area" },
                {
                  title: "Signatory from partner organization",
                  field: "partner_signatory_area",
                },
                // { title: "Logo", field: "logo", type: "imageFull" },
                // { title: "Domain listing", field: "domain_list" },
                { title: "Start Date", field: "from_date", type: "fullDate" },
                { title: "End Date", field: "to_date", type: "fullDate" },
                { title: "Status", field: "status" , type: "mouStatus"}
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {adminType === 23 && (
          <>
            <CustomTable
              {...props}
              columns={[
                // { title: "Image", field: "photo", type: "image" },
                { title: "Sl No", field: "slno" },
                { title: "Organization", field: "organization_name" },
                { title: "Signatory from KSPACE", field: "kspace_signatory_area" },
                {
                  title: "Signatory from partner organization",
                  field: "partner_signatory_area",
                },
                // { title: "Logo", field: "logo", type: "imageFull" },
                // { title: "Domain listing", field: "domain_list" },
                { title: "Start Date", field: "from_date", type: "fullDate" },
                { title: "End Date", field: "to_date", type: "fullDate" },
                { title: "Status", field: "status" , type: "mouStatus"}
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete MOU ?"
          data={activeData}
          message="Are you sure to delete this MOU?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}

